import React, { useEffect, useState } from "react";
import { Modal } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import Preloader from "~/components/Preloader";
import FormContract, {
  contractFormId,
} from "~/pages/ListOfDocuments/Modals/Components/FormContract";
import { useGetActiveRequisite } from "~/entity/AvtovazRequisites";
import { useGetContractById, useUpdateContract } from "~/entity/Contract";
import {
  editContractToForm,
  editContractToServer,
} from "~/pages/ListOfDocuments/Modals/helper";
import { TITLES } from "~/pages/ListOfDocuments/Modals/options";
import { useTrustedPersons } from "~/pages/ListOfDocuments/hooks/useTrustedPersons";
import { useNotify } from "~/shared/hooks/useNotify";

interface EditContractIProps {
  open: boolean;
  onClose: () => void;
  dealerObj: any;
  print: boolean;
}

const EditContract = ({
  open,
  onClose,
  dealerObj,
  print,
}: EditContractIProps) => {
  const [stateForm, setStateForm] = useState(null);
  const [confidant, setConfidant] = useState(null);
  const { data: requisite } = useGetActiveRequisite();
  const [loading, setLoading] = useState(false);
  const { notifySuccess, notifyError } = useNotify();
  const { t } = useTranslation();

  const { data: contractItem, isLoading: isLoadingContractItem } =
    useGetContractById(dealerObj.contractId, dealerObj.printFormId);
  const { mutate } = useUpdateContract();

  const { dataOptions, trustedPersonsState } = useTrustedPersons();

  useEffect(() => {
    if (trustedPersonsState?.data) {
      const dataConfidant = dataOptions.find(
        (item) => Number(item.value) === Number(dealerObj.confidantId),
      );
      setConfidant(dataConfidant);
    }
  }, [trustedPersonsState?.data]);

  useEffect(() => {
    if (contractItem && requisite && confidant) {
      setStateForm(
        editContractToForm(dealerObj, contractItem, requisite, confidant),
      );
      setLoading(true);
    }
  }, [contractItem, requisite, confidant]);

  const submit = (data) => {
    mutate(
      {
        data: editContractToServer(data),
        id: dealerObj.contractId,
      },
      {
        onSuccess: () => {
          notifySuccess(t("contract.update_contract_success"));
          onClose();
        },
        onError: () => {
          notifyError(t("contract.update_contract_error"));
        },
      },
    );
  };

  return (
    <Modal
      open={open}
      title={TITLES.doc.edit}
      onCancel={onClose}
      centered
      destroyOnHidden
      size="large"
      cancelButton={{ children: "Закрыть" }}
      okButton={
        loading
          ? {
              htmlType: "submit",
              form: contractFormId,
              children: "Сохранить",
            }
          : undefined
      }
    >
      {loading ? (
        <FormContract
          defaultValues={stateForm}
          submit={submit}
          dealerId={dealerObj.dealerId}
          contractId={dealerObj.contractId}
          printContract={print}
        />
      ) : (
        <Preloader />
      )}
    </Modal>
  );
};

export default EditContract;
